import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';
import { NbaTargetTypes } from '~/app/tracking/feld-m-types';

const q6: PartialCarConfiguration = {
	combinations: ['trimLine', 'equipmentPackages', 'packages', 'paint', 'rims', 'interiorPackages', 'steeringWheels'],
	nextBestActions: [
		{
			icon: '',
			description: 'Audi Wallbox kaufen',
			labelText: 'Audi Wallbox',
			target: '_blank',
			trackingName: NbaTargetTypes.BuyWallbox,
			url: 'https://audi.elli.eco/de-DE/shop/configurator',
		},
		{
			icon: 'send',
			description: 'Verkaufsberater kontaktieren',
			labelText: 'Verkaufsberater kontaktieren',
			target: '_blank',

			trackingName: 'contact',
			url: 'https://api.my.audi.de/form/v1/forms/brandportalfd/salesperson-de-de?apiKey=brandportal-html&embedded=false&src=conf&vmt={{carline}}&vmn={{trimline}}&vac={{audiCode}}&vcl={{carlineId}}&vft={{financeProd}}&vmy={{modelYear}}&vc=EUR&pcl=https%3A%2F%2Fwww.audi.de%3D{{audiCode}}',
		},
	],
};

const sq6etron: PartialCarConfiguration = {
	...q6,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/sq6etron.html',
};

const q6etron: PartialCarConfiguration = {
	...q6,
	deliveryCostUrl: 'https://audi.de/de/brand/de/tools/nemo/commons/delivery-costs/q6etron.html',
};

const q6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q6etron, q6etron_ui, sq6etron, sq6etron_ui };
